import config from "@Config/index";
import axios from "axios";

const fetchNearbyLocations = async ({ id }: { id: any }) =>
  axios.get(`${config.API_URL}/api/v0/inventories/${id}/nearby_locations`, {
    params: {
      location_types:
        "university,bus_station,train_station,supermarket,pharmacy,restaurant,hospital,police,shopping_mall",
    },
  });

export default fetchNearbyLocations;
